import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Wrapper from '../common/Wrapper';
import Header from '../common/Header';
import NotificationBanner from '../common/NotificationBanner';
import Typography from "material-ui/Typography";
import Button from 'material-ui/Button';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#FAFAFA",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  content: {
    transform: 'translateY(20px)',
    padding: '60px',
    boxSizing: 'border-box',
  },

  flex: {
    display: 'flex',
    boxSizing: 'border-box',
  },

  card: {
    display: "flex",
    flexDirection: 'column',
    alignItems: 'center',
    width: "370px",
    background: "#FFFFFF",
    border: '1px solid #E7E9EB',
  },

  imgContainer: {
    padding: '30px 0px',
  },

  img: {
    width: '234px',
    height: '234px',
  },

  descriptionContainer: {
    borderTop: '1px solid #E7E9EB',
    padding: '0 20px 30px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  title: {
    width: '100%',
    textAlign: 'center',
    color: '#181819',
    fontSize: '16px',
    fontWeight: 'bold',
  },

  description: {
    fontSize: "11px",
    width: "100%",
    marginTop: "22px",
  },

  btn: {
    marginTop: '40px',
    padding: '10px 0',
    width: "192px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnDisable: {
    border: "1px solid #ECEDEF",
    background: "#ECEDEF",
    color: "#000000",
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },
});

class LetterGenerate extends React.Component {
  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const { classes } = this.props;

    return (
      <Wrapper className={classes.root}>
        <NotificationBanner user={this.props.user} />
        <Header title="レター文面作成" type="dark" hasBackBtn={false} />
        <div className={classes.main}>
          <div className={classes.content}>
            <div className={classes.flex}>
              <div className={classes.card} style={{ marginRight: "12px" }}>
                <div className={classes.imgContainer}>
                  <img
                    src={require(`../../assets/images/letter-auto-generate.png`)}
                    alt="文章添削"
                    className={classes.img}
                  />
                </div>
                <div className={classes.descriptionContainer}>
                  <div className={classes.title} style={{ marginTop: '30px' }}>
                    レターの文面のサンプルを自動生成
                  </div>
                  <Typography
                    variant="body2"
                    className={classes.description}
                  >
                    <div>
                      ChatGPTを使って、キーワードから営業レターのサンプルを生成します。
                    </div>
                  </Typography>
                  <Button
                    className={classNames(classes.btn, classes.btnEnable)}
                    onClick={() => this.props.goTo("/letter-auto-generate/create")}
                  >
                    レターサンプルを自動生成
                  </Button>
                </div>
              </div>

              <div className={classes.card}>
                <div className={classes.imgContainer}>
                  <img
                    src={require(`../../assets/images/letter-correction.png`)}
                    alt="文章添削"
                    className={classes.img}
                  />
                </div>
                <div className={classes.descriptionContainer}>
                  <div className={classes.title} style={{ marginTop: '30px' }}>
                    レターの文面を添削する
                  </div>
                  <Typography
                    variant="body2"
                    className={classes.description}
                  >
                    <div>
                      書き上がったレターの文章を添削する機能です。ChatGPTを使ってすぐに添削。
                    </div>
                  </Typography>
                  <Button
                    className={classNames(classes.btn, classes.btnEnable)}
                    onClick={() => this.props.goTo("/letter-corrections/create")}
                  >
                    レター文面添削
                  </Button>
                </div>
              </div>
            </div>
            <Typography
              variant="body2"
              style={{ marginTop: 10, color: '#181819' }}
            >
              ※ 入力されたデータがChatGPTの学習データに利用されることはありません。
            </Typography>
          </div>
        </div>
      </Wrapper>
    )
  }
}

LetterGenerate.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
};

export default withStyles(styles)(LetterGenerate);



// WEBPACK FOOTER //
// ./src/components/LetterGenerate/LetterGenerate.jsx